module.exports = __webpack_public_path__ + "static/media/rbahn-o-echtzeit.22fd07a8.svg";